import { NotificationType } from 'core/enums';

export interface MyNotificationModel {
    id: number;
    notificationId: number;
    title: string;
    messageText: string;
    notificationType: NotificationType;
    sentAt: string;
    isRead: boolean;
    readAt: string | null;
}

export interface MyNotificationsPagedModel {
    unreadCount: number;
    data: MyNotificationModel[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export interface LatestCriticalMessageModel {
    id: number;
    title: string;
    messageText: string;
    createdAt: string;
}

export interface UnreadNotificationsCountModel {
    unreadCount: number;
    latestCriticalMessage: LatestCriticalMessageModel | null;
}

export interface MarkNotificationReadModel {
    id: number;
    isRead: boolean;
    readAt: string;
}

export interface MarkAllNotificationsReadModel {
    updatedCount: number;
    readAt: string;
    unreadCount: number;
}

export interface MyNotificationsRequestModel {
    isRead?: boolean;
    page: number;
    pageSize: number;
}
